import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ICONS } from '@constants';
import classes from './index.module.css';

export const ErrorBar = ({
  message, canClose, onClose, className,
}) => (
  <section className={`${classes.error} ${className}`}>
    <section className={classes.message}>
      <section className={classes.icon}>
        <img src={ICONS.WARN} className={classes.warn_icon} alt="" />
      </section>
      {message}
    </section>
    {canClose ? (
      <IconButton
        className={classes.close_btn}
        aria-label=""
        size="small"
        color="dark"
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    ) : null}
  </section>
);
